import { render, staticRenderFns } from "./OrderAckButton.vue?vue&type=template&id=f60226e4&scoped=true"
import script from "./OrderAckButton.vue?vue&type=script&lang=js"
export * from "./OrderAckButton.vue?vue&type=script&lang=js"
import style0 from "./OrderAckButton.vue?vue&type=style&index=0&id=f60226e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f60226e4",
  null
  
)

export default component.exports